import { MaterialRequisitionDocumentRequest } from '@Types/api/form';

export const initialDocumentValuesForm: MaterialRequisitionDocumentRequest = {
  docDesc: '',
  docName: '',
  filePath: '',
  isConfidential: 0,
  matId: 0,
  procDocTypeId: 1,
  reqId: 0,
  deleteFlag: 0,
  documentExternalId: '',
};
